module.exports = __webpack_public_path__ + "img/nothing.9a8cb288.png";